@if (filterCondition) {
  <div class="filter-condition"
    [ngClass]="{'highlight-same-type' : highlightSameType, 'selected': selected}" (click)="select()">
    <div class="drag-handle" draggable="true" (dragstart)="onDragConditionStart($event)"
      (dragend)="onDragConditionEnd($event)">
      <div aria-hidden="false">
        <sc-icon iconClass="fa-bars"></sc-icon>
      </div>
    </div>
    <div class="label">
      <sc-dictionary-label [dictionaryKey]="nameDictionaryKey"></sc-dictionary-label>
    </div>
    <div class="delete-button" (click)="deleteCondition()">
      <sc-icon iconClass="fa-trash"></sc-icon>
    </div>
  </div>
}
